module.exports = __webpack_public_path__ + "static/010-9a4bdd33c773cea00a97a6fc66984462.jpeg";